import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import { updateSale } from "../../../../services/SaleService";
import currencyBRFormat from "../../../../util/CurrencyUtils";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import MultiPayment from "../../../../components/Multipayment";
import paymentMethodBR from "../../../../util/paymentMethodUtils";
const dayjs = require("dayjs");

export const CorrigirVendaModal = (props) => {
  const [sale, setSale] = useState();
  const inputPaymentMethod = useRef("");
  const [isOpen, setIsOpen] = useState(false);
  const [discount, setDiscount] = useState(0.0);
  const [priceWithDiscount, setPriceWithDiscount] = useState(0.0);
  const [totalWithDiscount, setTotalWithDiscount] = useState(0.0);
  const [loading, setLoading] = useState(false);
  const [discountTypePercentual, setDiscountTypePercentual] = useState(true);
  const [adtionalValue, setadtionalValue] = useState(0);
  const [paymentList, setPaymentList] = useState([]);
  const [multiPayment, setMultiPayment] = useState(false);

  const opened = { key: "OPENED", label: "Abertas", value: "Abertas" };

  useEffect(() => {
    setIsOpen(props.open);
    setSale(props.sale);
    setTotalWithDiscount(
      parseFloat(props.sale.total) +
      props.sale.adtionalValue -
      props.sale.discount
    );
    handleMultiPayment(props.sale);
  }, [props]);

  useEffect(() => {
    setSale(props.sale);
  }, [multiPayment]);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      validatePaidValue();
      const execute = window.confirm(
        "Tem certeza que deseja corrigir esta venda?"
      );

      if (execute) {
        setLoading(true);
        const data = {
          paymentList: treatMultiPayment(),
        };

        updateSale(props.sale.id, data)
          .then((response) => {
            toast.success(response);
            props.setStatus(opened);
            toggle();
          })
          .catch((error) => {
            if (error.response.status == 422) toast.error(error.response.data);
            else toast.error("Não foi possível corrigir esta venda");
            setLoading(false);
          });
      }
    } catch (error) {
      console.error(error.message);
      toast.error(error.message);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (sale) {
      setPriceWithDiscount(
        discountTypePercentual ? calculatePercentDiscount() : discount
      );
      calculateTotal();
    }
  }, [discountTypePercentual, discount, adtionalValue]);

  function calculatePercentDiscount() {
    return (
      (parseFloat(discount) / 100) *
      (parseFloat(sale.total) + parseFloat(adtionalValue))
    ).toFixed(2);
  }

  function calculateTotal() {
    setTotalWithDiscount(
      parseFloat(sale.total) +
      parseFloat(adtionalValue) -
      (discountTypePercentual ? calculatePercentDiscount() : discount)
    );
  }

  function toggle() {
    props.setOpen(false);
  }

  function treatMultiPayment() {
    if (inputPaymentMethod.current) {
      return [
        { key: inputPaymentMethod.current.value, value: totalWithDiscount },
      ];
    }

    return paymentList;
  }

  function validatePaidValue() {
    const paidValue = treatMultiPayment()
      .map((p) => p.value)
      .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
    if (paidValue < totalWithDiscount) {
      throw new Error("Valor das formas de pagamento insufiente");
    }
  }

  function addPayment(paymentMethod, paymentValue) {
    const payment = paymentList.find(
      (p) => p.key == paymentMethod.current.value
    );

    if (paymentValue && paymentValue > 0) {
      const paidValue = paymentList
        .map((p) => p.value)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);

      if (paidValue + parseFloat(paymentValue) > totalWithDiscount) {
        toast.warning(
          `Não pode adicionar pagamento, resta pagar ${currencyBRFormat(
            totalWithDiscount - paidValue
          )}`
        );
        return;
      }
      if (payment) {
        toast.warning(
          `Forma de pagamento ${paymentMethodBR(
            paymentMethod.current.value
          )} já adicionada, remova ou adicione uma diferente`
        );
        return;
      }
      const item = {
        key: paymentMethod.current.value,
        name: paymentMethodBR(paymentMethod.current.value),
        value: paymentValue,
      };
      setPaymentList((prev) => [...prev, item]);
    } else {
      toast.warning("Valor da forma de pagamento deve ser maior que zero");
    }
  }

  function handleMultiPayment(sale) {
    if (sale && sale.paymentList.length > 1) {
      setMultiPayment(true);
      setPaymentList(sale.paymentList);
    }
  }

  if (!sale) return null;
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
        size="lg"
        centered
        contentClassName="border-0 rounded-4 shadow-lg"
      >
        <ModalHeader toggle={toggle} className="border-bottom-0 pb-0 pt-4 px-4">
          <div className="d-flex flex-column">
            <span className="fw-bold text-primary">Corrigir Venda</span>
            <small className="text-muted fw-normal">
              Realizada em: {dayjs(sale.createdAt).format("DD/MM/YYYY HH:mm")}
            </small>
          </div>
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody className="p-4">
            {/* SEÇÃO 1: PAGAMENTO E CLIENTE (ESTILO CARD) */}
            <div className="row mb-4">
              <div className="col-lg-6 mb-lg-0 mb-3">
                <div className="bg-light p-3 rounded-3 border h-100">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <label className="form-label fw-bold text-muted small text-uppercase mb-0">
                      <i className="fas fa-cash-register me-1"></i> Formas de pagamento
                    </label>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                        checked={multiPayment}
                        onChange={() => setMultiPayment(!multiPayment)}
                      />
                      <label className="form-check-label small fw-bold" htmlFor="flexSwitchCheckDefault">
                        {multiPayment ? "Várias" : "Uma"}
                      </label>
                    </div>
                  </div>

                  {multiPayment ? (
                    <MultiPayment
                      inputPaymentMethod={inputPaymentMethod}
                      paymentList={paymentList}
                      addPayment={addPayment}
                      setPaymentList={setPaymentList}
                      totalWithDiscount={totalWithDiscount}
                    />
                  ) : (
                    <select
                      id="paymentMethod"
                      ref={inputPaymentMethod}
                      className="form-select border-2 fw-bold text-dark rounded-3"
                      defaultValue={sale.paymentList[0] ? sale.paymentList[0].key : null}
                      required
                    >
                      <option value="MONEY">Dinheiro</option>
                      <option value="CREDIT">Crédito</option>
                      <option value="DEBIT">Débito</option>
                      <option value="PIX">Pix</option>
                    </select>
                  )}
                </div>
              </div>

              <div className="col-lg-6">
                <div className="bg-light p-3 rounded-3 border h-100">
                  <label htmlFor="customerSelect" className="form-label fw-bold text-muted small text-uppercase">
                    <i className="fas fa-user me-1"></i> Cliente (Bloqueado)
                  </label>
                  <Select
                    isDisabled={true}
                    id="customerSelect"
                    name="customers"
                    classNamePrefix="select"
                    defaultValue={{
                      label: sale.customer ? sale.customer.name : "Não identificado",
                    }}
                    styles={{
                      control: (base) => ({ ...base, borderRadius: '8px', backgroundColor: '#e9ecef' })
                    }}
                  />
                  <small className="text-muted mt-2 d-block" style={{ fontSize: '0.7rem' }}>
                    * Para mudar o cliente, exclua a venda e lance novamente.
                  </small>
                </div>
              </div>
            </div>

            {/* SEÇÃO 2: TABELA DE ITENS (REVISÃO) */}
            <div className="border rounded-3 overflow-hidden mb-4">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr className="small text-uppercase text-muted">
                    <th className="px-3">Qtd</th>
                    <th>Descrição</th>
                    <th className="text-end px-3">Preço</th>
                  </tr>
                </thead>
                <tbody>
                  {props.sale.servicesAndParts.map((obj) => (
                    <tr key={obj.name}>
                      <td className="px-3 fw-bold">{obj.qtd}</td>
                      <td>{obj.name}</td>
                      <td className="text-end px-3 fw-medium">{currencyBRFormat(obj.price)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* SEÇÃO 3: RESUMO FINANCEIRO (HIGHLIGHT) */}
            <div className="row g-2 text-center">
              <div className="col-lg-3">
                <div className="p-2 border rounded-3 bg-white shadow-sm h-100">
                  <div className="small text-muted fw-bold text-uppercase" style={{ fontSize: '0.65rem' }}>Subtotal</div>
                  <div className="fw-bold text-dark">{currencyBRFormat(sale.total)}</div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="p-2 border rounded-3 bg-white shadow-sm h-100">
                  <div className="small text-muted fw-bold text-uppercase" style={{ fontSize: '0.65rem' }}>Adicional</div>
                  <div className="fw-bold text-primary">+{currencyBRFormat(sale.adtionalValue)}</div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="p-2 border rounded-3 bg-white shadow-sm h-100">
                  <div className="small text-muted fw-bold text-uppercase" style={{ fontSize: '0.65rem' }}>Desconto</div>
                  <div className="fw-bold text-danger">-{currencyBRFormat(sale.discount)}</div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="p-2 border rounded-3 bg-success text-white shadow h-100">
                  <div className="small fw-bold text-uppercase opacity-75" style={{ fontSize: '0.65rem' }}>Total Final</div>
                  <div className="h5 fw-bold mb-0">{currencyBRFormat(totalWithDiscount)}</div>
                </div>
              </div>
            </div>
          </ModalBody>

          <ModalFooter className="border-top-0 p-4 pt-0">
            {!loading ? (
              <div className="d-flex w-100 gap-2">
                <button type="submit" className="btn btn-primary btn-lg fw-bold flex-grow-1 rounded-3 shadow-sm">
                  <i className="fas fa-save me-2"></i> Salvar Correção
                </button>
                <button type="button" onClick={toggle} className="btn btn-outline-danger btn-lg rounded-3 border-2">
                  Cancelar
                </button>
              </div>
            ) : (
              <div className="d-flex justify-content-center w-100 py-2">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Corrigindo...</span>
                </div>
              </div>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
};

export default CorrigirVendaModal;
